import { UiNotification } from '@/staff/models/ui-notifications';

export class UiNotificationUtils {
    static getNotificationByIdentifier(notifications: Array<UiNotification>, identifier: string): UiNotification | null {
        return notifications.find(notification => notification.identifier === identifier) ?? null;
    }
}
